import { useCallback, useEffect, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { getInboxBrand } from '@idk-web/api';
import {
  resetBrand,
  inboxBrand,
  updateBrand,
  type InboxBrandState,
} from '@/state/inboxBrand';
import { inboxLoginStatus } from '@/state/inboxAuth';

export type Brand = {
  brand: InboxBrandState | null;
  reload(): Promise<void>;
};

/**
 * Returns the current inbox brand.
 */
export function useInboxBrand(): Brand {
  const loginStatus = useAtomValue(inboxLoginStatus);
  let brand: InboxBrandState | null = useAtomValue(inboxBrand);

  // Brand always returns an object, but we want to treat it as null if it's empty
  brand = brand?.name ? brand : null;

  const reload = useCallback(async () => {
    try {
      const brand = await getInboxBrand();

      updateBrand(brand);
    } catch {
      resetBrand();
    }
  }, []);

  useEffect(() => {
    if (loginStatus === 'LOGGED_IN' && brand) {
      return;
    }

    void reload();
  }, []);

  return useMemo(
    () => ({
      brand,
      reload,
    }),
    [brand, reload],
  );
}
